import classNames from 'classnames';
import { useField, useFormikContext } from 'formik';
import { useMemo } from 'react';
import { Flex, Heading } from 'yoso';
import { BaseCard } from '~/components/Card';
import { useEvolution } from '~/components/Evolve/Evolve.hooks';
import { EvolveValues } from '~/components/Evolve/Form/EvolveForm.hooks';
import styles from '~/components/Evolve/Select/Card/EvolveSelectCard.module.scss';
import { EvolveSelectField } from '~/components/Evolve/Select/Field/EvolveSelectField';
import { T } from '~/components/I18n';

export type EvolveSelectCardProps = {
  className?: string;
  name?: string;
};

export const EvolveSelectCard = ({ name = 'tokenIdList', className }: EvolveSelectCardProps) => {
  const {
    values: { tokenType = '' },
  } = useFormikContext<EvolveValues>();
  const [{ value: tokenIdList }] = useField<EvolveValues['tokenIdList']>(name);
  const count = useMemo(() => tokenIdList.filter(Boolean).length, [tokenIdList]);

  const { data } = useEvolution(tokenType);

  return (
    <BaseCard className={classNames(styles.root, className)} shadow size="large">
      <Flex className={styles.header} container justifyContent="space-between">
        <Heading className={styles.title} level={5}>
          <T name="citizen_evolve_popup_my_friends" options={[data.growth || 'Friends']} />
        </Heading>
        <span className={styles.count}>
          <strong>{count}</strong> / {data.minNftAmount}
        </span>
      </Flex>
      <EvolveSelectField className={styles.select} name={name} tokenType={tokenType} />
    </BaseCard>
  );
};
